import Vue from "vue";
import store from "./vuex/store.js";
import IMstore from './store/index'
/*引入样式文件*/
import "element-ui/lib/theme-chalk/index.css"; //element-ui 样式文件
import router from "./route";
import "./style/app.scss";
import ElementUi from "element-ui";
import Install from "./js/lib/install";
import App from './js/App'
import VueClipboard from 'vue-clipboard2';
import vuescroll from 'vuescroll'
// import SDKAppID from './appid'
import vueEsign from 'vue-esign'

Vue.use(vueEsign)
window.IMstore = IMstore;
Vue.prototype.$IMstore = IMstore;
import { TUICallEngine} from "tuicall-engine-webrtc";
//从本地获取SDKAppID
let SDKAppID=Number(window.sessionStorage.getItem("videoAppId"))
console.log(`====从本地获取SDKAppID===main======>`,SDKAppID)
if(SDKAppID!==0){
    //////////初始化TUICallEngine//////////
    Vue.prototype.SDKAppID = SDKAppID;
    let tuiCallEngine = TUICallEngine.createInstance({SDKAppID});
    Vue.prototype.tuiCallEngine=tuiCallEngine
    console.log(`====tuiCallEngine===初始化成功======>`,Vue.prototype.tuiCallEngine)
}else{
    console.log(`====从本地获取SDKAppID=====else==main==>`,SDKAppID)
}

Vue.prototype.hosId = '01001';

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)
// console.log(`========vConsole=====>`,vConsole)

//////////初始化TUICallEngine////end//////
// import TIM from 'tim-js-sdk';
// import TIMUploadPlugin from 'tim-upload-plugin';
// const tim1 = TIM.create({
//     SDKAppID: SDKAppID,
// });
// tim1.setLogLevel(1);
// Vue.prototype.tim = tim1;
// 注册腾讯云即时通信 IM 上传插件
// console.log(`=======注册腾讯云即时通信 IM 上传插件======>`,)
// tim1.registerPlugin({'tim-upload-plugin': TIMUploadPlugin});

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(vuescroll);
window.onresize = function() {
    const clientH =
        document.documentElement.clientHeight || document.body.clientHeight;
        store.dispatch("getClientH", clientH - 1);
};
Vue.use(Install);
Vue.use(ElementUi);
window.bus = new Vue();
let vm = new Vue({
    el: document.getElementById('app'),
    router,
    store,
    render: (h) => h(App)
    // template: '<App/>',
    // components: { App }
})